const splitAccept = (accept: string): string[] =>
  accept
    .split(",")
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);

export const getFileExtension = (filename: string): string => {
  const dot = filename.lastIndexOf(".");
  return dot > 0 ? filename.slice(dot).toLowerCase() : "";
};

export const doesFileMatchAccept = (
  file: File,
  accept: string | undefined,
): boolean => {
  if (!accept?.trim()) return true;

  const acceptedTypes = splitAccept(accept);
  if (acceptedTypes.length === 0) return true;

  const filename = file.name.toLowerCase();
  const extension = getFileExtension(filename);
  const mimeType = file.type.toLowerCase();

  return acceptedTypes.some((acceptedType) => {
    if (acceptedType.startsWith(".")) {
      return extension === acceptedType;
    }

    if (acceptedType.endsWith("/*")) {
      const mimePrefix = acceptedType.slice(0, -1);
      return mimeType.startsWith(mimePrefix);
    }

    return mimeType === acceptedType;
  });
};

export const formatAcceptForMessage = (accept: string): string =>
  splitAccept(accept).join(", ");

/** 형식이 맞지 않는 파일을 돌려보낼 때의 안내 — 한 개씩 고르든 여러 개를 끌어 놓든 같은 문구. */
export const acceptErrorMessage = (accept: string): string =>
  `지원하지 않는 파일 형식입니다. ${formatAcceptForMessage(
    accept,
  )} 파일만 업로드할 수 있습니다.`;
